import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {IOfferDetail} from "../../offer/types/IOfferDetail";
import {IPropertyDetailPromotion} from "../../property/actions/fetch_property_detail_promotions";
import {useBooster} from "../hooks/use_booster";
import {useBoosterAnalytics} from "../hooks/use_booster_analytics";
import {IFlatInvestmentBoosterParams} from "../types/booster_generic/IFlatInvestmentBooster";
import {IHouseInvestmentBoosterParams} from "../types/booster_generic/IHouseInvestmentBooster";
import {IBoosterClickHandlerParams} from "../types/IBoosterClickHandlerParams";
import {BoosterPopover} from "./parts/BoosterPopover";
import {BoosterText} from "./parts/BoosterText";

export interface IOfferBoosterProps {
    offer: IOfferDetail;
    promotions: IPropertyDetailPromotion[] | null;
    onBoosterClick?: (params: IBoosterClickHandlerParams) => void;
    className?: string;
}

export const OfferBooster = (props: IOfferBoosterProps) => {
    const {promotions, offer, className} = props;
    const userPref = useSelector((state: IRPStore) => state.user.preferences?.data || null);

    const {segments, metadata} = useBooster<IHouseInvestmentBoosterParams | IFlatInvestmentBoosterParams>({
        offerId: offer.id,
        userPref,
        offer,
        promotions
    });
    const {trackBoosterClick} = useBoosterAnalytics<IHouseInvestmentBoosterParams | IFlatInvestmentBoosterParams>({segments, metadata});

    const handleBoosterClick = (closeBooster: () => void) => {
        if (props.onBoosterClick && metadata?.category && metadata?.type) {
            trackBoosterClick();

            props.onBoosterClick({
                category: metadata.category,
                type: metadata.type
            });
            closeBooster();
        }
    };

    return segments ? <BoosterPopover handleBoosterClick={handleBoosterClick} bodyText={<BoosterText text={segments} />} className={className} /> : null;
};
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {IOfferDetail} from "../../offer/types/IOfferDetail";
import {IPropertyDetailPromotion} from "../../property/actions/fetch_property_detail_promotions";
import {useBooster} from "../hooks/use_booster";
import {useBoosterAnalytics} from "../hooks/use_booster_analytics";
import {IFlatInvestmentBoosterParams} from "../types/booster_generic/IFlatInvestmentBooster";
import {IHouseInvestmentBoosterParams} from "../types/booster_generic/IHouseInvestmentBooster";
import {IBoosterClickHandlerParams} from "../types/IBoosterClickHandlerParams";
import {BoosterPopover} from "./parts/BoosterPopover";
import {BoosterText} from "./parts/BoosterText";

export interface IOfferBoosterProps {
    offer: IOfferDetail;
    promotions: IPropertyDetailPromotion[] | null;
    onBoosterClick?: (params: IBoosterClickHandlerParams) => void;
    className?: string;
}

export const OfferBooster = (props: IOfferBoosterProps) => {
    const {promotions, offer, className} = props;
    const userPref = useSelector((state: IRPStore) => state.user.preferences?.data || null);

    const {segments, metadata} = useBooster<IHouseInvestmentBoosterParams | IFlatInvestmentBoosterParams>({
        offerId: offer.id,
        userPref,
        offer,
        promotions
    });
    const {trackBoosterClick} = useBoosterAnalytics<IHouseInvestmentBoosterParams | IFlatInvestmentBoosterParams>({segments, metadata});

    const handleBoosterClick = (closeBooster: () => void) => {
        if (props.onBoosterClick && metadata?.category && metadata?.type) {
            trackBoosterClick();

            props.onBoosterClick({
                category: metadata.category,
                type: metadata.type
            });
            closeBooster();
        }
    };

    return segments ? <BoosterPopover handleBoosterClick={handleBoosterClick} bodyText={<BoosterText text={segments} />} className={className} /> : null;
};
